export const optionShape = React.PropTypes.shape({
  value: React.PropTypes.any,
  label: React.PropTypes.string,
});

export default React.PropTypes.arrayOf(optionShape);



// WEBPACK FOOTER //
// ./src/shared/shapes/dropdown-options.js